import { esusApi } from "@/services/api";
import { GroupActivityCitizen } from "@/@types/esus/GroupActivityCitizen";

export type DetailedCitizenGroupActivitiesIndicatorB4Params = {
	uf: string;
	ibgeCode: string;
	quarter: string;
	year: number;
	month: number;
	ine?: string;
	citizenId: number;
};

export class DetailedCitizenGroupActivitiesIndicatorB4 {
	id: number = 0;
	cpf?: string;
	cns?: string;
	birthdate: string = "";
	fullName: string = "";
	area?: string;
	motherName?: string;
	gender?: number;
	street?: string;
	houseNumber?: string;
	neighborhood?: string;
	phone?: string;
	healthTeamId: number = 0;
	healthTeamIne: string = "";
	healthTeamName: string = "";
	groupActivityCitizens?: GroupActivityCitizen[];
}

export async function getDetailedCitizenGroupActivitiesIndicatorB4({
	uf,
	ibgeCode,
	...params
}: DetailedCitizenGroupActivitiesIndicatorB4Params) {
	const response = await esusApi.get<DetailedCitizenGroupActivitiesIndicatorB4>(
		`/uf/${uf}/city/${ibgeCode}/indicator/esb/b4/detailed-citizen-group-activities`,
		params
	);
	return response.data ?? new DetailedCitizenGroupActivitiesIndicatorB4();
}
